import APIService from 'services/APIService';
import Role, { RoleDTO } from 'models/onboarding/role/Role';

export type GetRoleParameters = {
	roleId: string;
};

export default class RoleService {
	constructor(private readonly ApiService: APIService) {}

	fetchRole({ roleId }: GetRoleParameters) {
		return this.ApiService.get<RoleDTO>(`/role/${roleId}`, undefined, undefined, {
			version: 'v2',
			controller: 'workflows',
		}).then(response => this.toModel(response));
	}

	toModel(role: RoleDTO): Role {
		return new Role(role);
	}
}
